import { render, staticRenderFns } from "./get-referrals.vue?vue&type=template&id=67ae9dbb&scoped=true&"
import script from "./get-referrals.vue?vue&type=script&lang=js&"
export * from "./get-referrals.vue?vue&type=script&lang=js&"
import style0 from "./get-referrals.vue?vue&type=style&index=0&id=67ae9dbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae9dbb",
  null
  
)

export default component.exports